export enum AdvertisementProviderTypes {
  Automatic = 'AUTOMATA',
  Manual = 'MANUAL',
}
